<template>
	<div>
		<van-cell center :value="value" :required="formCreateInject.rule.validate[0].required" input-align="right"
			:title="formCreateInject.prop.title.title">
			<template #right-icon>
				<div class="mounte_container" :id="containerid"></div>
			</template>
		</van-cell>
	</div>
</template>

<style scoped>
	.container {
		position: re;
		box-sizing: border-box;
		padding: 10px;
		padding-top: 0px;
		width: 600px;

	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		data() {
			return {
				containerid: 'container_' + Math.random(),
				visible: false,
				collection: 0,
				component: null
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			submit() {

			},
			close() {
				this.visible = false
			},
			setComponent(component) {
				this.component = component
				document.getElementById(this.containerid).appendChild(component.$el)
			},
			buttonClick() {
				this.visible = !this.visible
				//this.$emit('buttonClick')
			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		},
		components: {

		},
	}
</script>
